import React from 'react';
import styles from "./Video.css"
import RegisterProgress from "../../components/features/register/RegisterProgress";
import Header from "../../components/features/login/Header";
import TitleModule from '../../components/features/register/TitleModule';
import VideoFile from "../../components/Introducao/VideoFile";

const Video = () => {
    return (
      <div className="video-Page"> 
        <Header/>
        <div className={styles.container}>
            <TitleModule/>
            <RegisterProgress step={2} title="Conheça a tecnologia" icon="Dvr"/>
            <VideoFile/>
        </div>
      </div>
    );
  };
  
  export default Video;
  